import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.7175 4.28236C10.425 4.57486 10.425 5.04736 10.7175 5.33986L13.6275 8.24986H2.25C1.8375 8.24986 1.5 8.58736 1.5 8.99986C1.5 9.41236 1.8375 9.74986 2.25 9.74986H13.635L10.725 12.6599C10.4325 12.9524 10.4325 13.4249 10.725 13.7174C11.0175 14.0099 11.49 14.0099 11.7825 13.7174L15.975 9.52486C16.2675 9.23236 16.2675 8.75986 15.975 8.46736L11.775 4.28236C11.49 3.98986 11.01 3.98986 10.7175 4.28236Z" })
});
export default SvgArrowRightAlt;
